import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {CitizensServicesRequirements} from './citizens-services-requirements.model';

export const loadCitizensServicesRequirementss = createAction(
  '[CitizensServicesRequirements/API] Load CitizensServicesRequirementss',
  props<{ citizensServicesRequirementss: CitizensServicesRequirements[] }>()
);

export const addCitizensServicesRequirements = createAction(
  '[CitizensServicesRequirements/API] Add CitizensServicesRequirements',
  props<{ citizensServicesRequirements: CitizensServicesRequirements }>()
);

export const upsertCitizensServicesRequirements = createAction(
  '[CitizensServicesRequirements/API] Upsert CitizensServicesRequirements',
  props<{ citizensServicesRequirements: CitizensServicesRequirements }>()
);

export const addCitizensServicesRequirementss = createAction(
  '[CitizensServicesRequirements/API] Add CitizensServicesRequirementss',
  props<{ citizensServicesRequirementss: CitizensServicesRequirements[] }>()
);

export const upsertCitizensServicesRequirementss = createAction(
  '[CitizensServicesRequirements/API] Upsert CitizensServicesRequirementss',
  props<{ citizensServicesRequirementss: CitizensServicesRequirements[] }>()
);

export const updateCitizensServicesRequirements = createAction(
  '[CitizensServicesRequirements/API] Update CitizensServicesRequirements',
  props<{ citizensServicesRequirements: Update<CitizensServicesRequirements> }>()
);

export const updateCitizensServicesRequirementss = createAction(
  '[CitizensServicesRequirements/API] Update CitizensServicesRequirementss',
  props<{ citizensServicesRequirementss: Update<CitizensServicesRequirements>[] }>()
);

export const deleteCitizensServicesRequirements = createAction(
  '[CitizensServicesRequirements/API] Delete CitizensServicesRequirements',
  props<{ id: string }>()
);

export const deleteCitizensServicesRequirementss = createAction(
  '[CitizensServicesRequirements/API] Delete CitizensServicesRequirementss',
  props<{ ids: string[] }>()
);

export const clearCitizensServicesRequirementss = createAction(
  '[CitizensServicesRequirements/API] Clear CitizensServicesRequirementss'
);



export const citizenGetServicesRequirements = createAction(
  '[CitizensServicesRequirements/API]  citizen Get Services Requirements',
  props<{ serviceUniqueId?:string }>()
);
